(function () {
    function initNewsletterPopup(root) {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
  
      const backdrop = root.querySelector('[data-newsletter-popup-backdrop]');
      const closeButtons = root.querySelectorAll('[data-newsletter-popup-close]');
      const form = root.querySelector('form');
      const success = root.querySelector('.newsletter-popup__success');
      const errors = root.querySelector('.newsletter-popup__errors');
      const sessionKey = root.dataset.sessionKey || 'newsletter-popup-seen';
      const scrollThreshold = parseFloat(root.dataset.scrollThreshold || '15');
      const isDesignMode = typeof Shopify !== 'undefined' && Shopify.designMode;
      let isVisible = false;
  
      function openPopup(force) {
        if (isVisible) return;
  
        if (!force && !isDesignMode && sessionStorage.getItem(sessionKey) === 'true') {
          return;
        }
  
        root.classList.add('is-visible');
        document.documentElement.classList.add('newsletter-popup-open');
        document.body.classList.add('newsletter-popup-open');
        isVisible = true;
  
        if (!isDesignMode) {
          sessionStorage.setItem(sessionKey, 'true');
        }
      }
  
      function closePopup() {
        root.classList.remove('is-visible');
        document.documentElement.classList.remove('newsletter-popup-open');
        document.body.classList.remove('newsletter-popup-open');
        isVisible = false;
      }
  
      function handleScroll() {
        if (isVisible || isDesignMode || sessionStorage.getItem(sessionKey) === 'true') {
          window.removeEventListener('scroll', handleScroll);
          return;
        }
  
        const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollableHeight <= 0) return;
  
        const scrollPercent = (window.scrollY / scrollableHeight) * 100;
  
        if (scrollPercent >= scrollThreshold) {
          openPopup(false);
          window.removeEventListener('scroll', handleScroll);
        }
      }
  
      if (backdrop) {
        backdrop.addEventListener('click', closePopup);
      }
  
      closeButtons.forEach(function (button) {
        button.addEventListener('click', closePopup);
      });
  
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && root.classList.contains('is-visible')) {
          closePopup();
        }
      });
  
      if (form) {
        form.addEventListener('submit', function () {
          if (!isDesignMode) {
            sessionStorage.setItem(sessionKey, 'true');
          }
        });
      }
  
      if (isDesignMode) {
        openPopup(true);
        return;
      }
  
      if (success || errors) {
        openPopup(true);
        return;
      }
  
      window.addEventListener('scroll', handleScroll, { passive: true });
    }
  
    function initAllNewsletterPopups(scope) {
      const container = scope || document;
      const popups = container.querySelectorAll('.newsletter-popup');
      popups.forEach(initNewsletterPopup);
    }
  
    document.addEventListener('DOMContentLoaded', function () {
      initAllNewsletterPopups(document);
    });
  
    document.addEventListener('shopify:section:load', function (event) {
      initAllNewsletterPopups(event.target);
    });
  })();